import { render, staticRenderFns } from "./inBox.vue?vue&type=template&id=e0fcfa1a&scoped=true"
import script from "./inBox.vue?vue&type=script&lang=js"
export * from "./inBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fcfa1a",
  null
  
)

export default component.exports